module.exports = __webpack_public_path__ + "static/media/free-root-beer-2024-mb-fr.3ec344c4.jpg";